<template>
    <div class="h-screen flex justify-center items-center text-gray-900">
        <div class="w-full max-w-md mx-auto">

            <h1 class="text-2xl mb-8">Complete Registration</h1>

            <template v-if="user.registration_completed_at">
                <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-8" role="alert">
                    <p class="font-bold">Warning</p>
                    <p>It looks like registration has already been completed for this account.</p>
                </div>

                <inertia-link class="inline-block text-primary" href="/login">
                    Continue to login
                </inertia-link>
            </template>

            <form v-else class="space-y-6" @submit.prevent="onSubmit">

                <InputBasic
                    :disabled="true"
                    label="Email"
                    name="email"
                    placeholder="Please enter your email..."/>

                <InputBasic
                    label="New Password"
                    name="password"
                    placeholder="Please enter your password..."
                    type="password"/>

                <InputBasic
                    label="Confirm New Password"
                    name="password_confirmation"
                    placeholder="Please confirm your password..."
                    type="password"/>

                <SubmitButton
                    :class="{'hover:bg-blue-100 hover:text-blue-700 active:text-blue-900': !form.errors.any()}"
                    :disabled="form.errors.any()"
                    :submitting="form.processing"
                    class="w-full text-blue-600 text-sm py-2 px-4 border border-blue-500 rounded">
                    Complete registration
                </SubmitButton>
            </form>
        </div>
    </div>
</template>

<script>

import Form from "form-backend-validation"
import InputBasic from "@app/Shared/Components/InputBasic";
import SubmitButton from "@app/Shared/Components/SubmitButton";

export default {

    props: {
        user: Object
    },

    data() {
        return {
            form: new Form({
                email: this.user.email,
                password: '',
                password_confirmation: ''
            }, {resetOnSuccess: false})
        }
    },

    components: {
        InputBasic,
        SubmitButton
    },

    methods: {
        onSubmit() {

            if (this.form.processing) {
                return;
            }

            this.form.post(this.$inertia.page.url)
                .then(response => {
                    window.location.href = "/admin";
                })
                .catch()
        }
    }
};

</script>
